import React from "react";
import "./footer.css";
import { useLocation } from "react-router-dom";

const Footer = props => {
  const location = useLocation();
  const isReportsPage = location.pathname === "/reports";
  return (
    !isReportsPage ?
      <div className={`footer-content${props?.login ? " login-page" : ""}`}>
        <hr />
        <div className="footer-description">
          <span>© 2024</span>
          <span>&nbsp;&nbsp;&#183;&nbsp;&nbsp;</span>
          <span>GoBeyond RegCom</span>
          <span>&nbsp;&nbsp;&#183;&nbsp;&nbsp;</span>
          <span>Developed by Grant Thornton</span>
        </div>
      </div>
    :
      <></>
  );
};

export default Footer;
